import React from "react"
import Container from "./Container"
import services_bg from "../images/home/services/services_bg.png"
import star from "../images/home/services/star.svg"
import link_icon from "../images/home/services/link_icon.svg"
import { Link } from "gatsby"

function Services() {
  return (
    <Container>
      <div className=" mb-[268px]">
        <p className="uppercase text-[24px] w-[80%] mb-[36px] lg:text-[40px] lg:w-[800px] font-[700] leading-[34px] lg:leading-[68px]">
          OUR SERVICES
        </p>
        <div className="flex flex-col lg:flex-row gap-4">
          <div
            style={{ backgroundImage: `url('${services_bg}')` }}
            className="aspect-[384/351] lg:aspect-[486/548] border w-full lg:w-[40%] lg: py-10 bg-cover bg-center rounded-[20px]"
          >
            {/* <img src={services_bg} alt="" /> */}
          </div>
          <div className="relative xl:aspect-[282/548] aspect-[384/280] p-8 w-full lg:w-[25%] bg-[#F5F5F5] py-10 rounded-[20px]">
            <img className="absolute right-10 top-10" src={star} alt="" />
            <p className="absolute font-[500] w-[70%] text-right bottom-16 text-[#000000] text-[24px]">
              GIVING YOUR HOME THE PERFECT ROOF
            </p>
          </div>
          <div className="h-auto pb-12 pt-36  flex flex-col lg:justify-end pb-[50px]  gap-6 px-10 w-full lg:w-[35%] bg-[#FF8616] flex-2 rounded-[20px]">
            <div>
              <Link
                to="/services/?tab=0#tabs"
                className="w-full flex items-center justify-between"
              >
                <p className="uppercase w-full text-[#FFFFFF] font-[600] ">
                  Roof
                  <br /> Installation
                </p>
                <img src={link_icon} alt="" />
              </Link>
              <hr className="border-t opacity-[0.2] mt-3 opacity-50 border-[#FFFFFF]" />
            </div>
            <div>
              <Link
                to="/services/?tab=1#tabs"
                className="w-full flex items-center justify-between"
              >
                <p className="uppercase w-full text-[#FFFFFF] font-[600] ">
                  Roof
                  <br />
                  Repairs
                </p>
                <img src={link_icon} alt="" />
              </Link>
              <hr className="border-t opacity-[0.2] mt-3 opacity-50 border-[#FFFFFF]" />
            </div>
            <div>
              <Link
                to="/services/?tab=2#tabs"
                className="w-full flex items-center justify-between"
              >
                <p className="uppercase w-full text-[#FFFFFF] font-[600] ">
                  Roof <br />
                  Maintenance
                </p>
                <img src={link_icon} alt="" />
              </Link>
              <hr className="border-t opacity-[0.2] mt-3 opacity-50 border-[#FFFFFF]" />
            </div>
            <div>
              <Link
                to="/services/?tab=3#tabs"
                className="w-full flex items-center justify-between"
              >
                <p className="uppercase w-full text-[#FFFFFF] font-[600] ">
                  damp <br /> works
                </p>
                <img src={link_icon} alt="" />
              </Link>
              <hr className="border-t opacity-[0.2] mt-3 opacity-50 border-[#FFFFFF]" />
            </div>
            <div>
              <Link
                to="/services/?tab=4#tabs"
                className="w-full flex items-center justify-between"
              >
                <p className="uppercase w-full text-[#FFFFFF] font-[600] ">
                  Emergency <br />
                  Services
                </p>
                <img src={link_icon} alt="" />
              </Link>
              <hr className="border-t opacity-[0.2] mt-3 opacity-50 border-[#FFFFFF]" />
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Services
